/*
 * pz-cart-notice.js
 * カートのページの上のお知らせ（デザインシミュレーター 段階 4。カートの行の差し替え）。
 * 設計: printeez-portal/docs/design-simulator/same-print-product-switch.html 3.2 の 6・3.3・4.2 の見本
 *
 * 専用ページ（assets/pz-design-embed.js）がカートの行を差し替えたときに localStorage（pz:cart-notice）に残した結果を、
 * カートのページの [data-pz-cart-notice]（snippets/pz-cart-notice.liquid）に出す。
 *   「デザインを更新しました」
 *   「カート内のN点も新しいデザインにしました。金額が変わっています」
 *   （金額が変わらなければ「金額が変わっています」は付けない。portal の cart-replace.ts の replaceNoticeText と同じ文）
 *   新しいデザインにできなかった商品・外した商品・消せなかった前の行・購入手続きの画面の案内（購入手続きが始まった版の行を差し替えたとき）
 *   お客様向けの文は短く、「行」「差し替え」「決済画面」は使わない。数字の前後に半角の空白を入れない（オーナーの方針）
 * 別の種類（kind: "merged"。段階 6 のエディタのカート）: ログインして端末のカートをお客様のカートにまとめたとき、
 * assets/pz-editor-cart.js が残す。「ログイン前のカートをまとめました（n点）」（n = まとめた枚数の合計）。kind の無いものは上の差し替えの知らせ。
 * どちらも「閉じる」で消す。2 時間たったら出さない。カートのページの描き直し（セクションの差し替え）で入れ物が作り直されたら出し直す。
 * 文字はすべて textContent で入れる（商品名・メッセージを HTML として扱わない）。
 */
(function () {
  'use strict';
  if (window.PzCartNotice) return;

  var STORAGE_KEY = 'pz:cart-notice';
  var MAX_AGE_MS = 2 * 60 * 60 * 1000;
  var CHECKOUT_OPEN_NOTICE =
    '購入手続きの画面を開いているときは、閉じてからカートでやり直してください。開いたままだと前のデザインで注文されます';

  function read() {
    var data = null;
    try {
      data = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      data = null;
    }
    if (!data || typeof data !== 'object' || data.v !== 1) return null;
    if (!(Number(data.at) > 0) || Date.now() - Number(data.at) > MAX_AGE_MS) return null;
    if (data.kind === 'merged' && !(Number(data.itemCount) > 0)) return null;
    return data;
  }

  function clear() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* 消せない環境では出し続けないよう、表示だけ消す */ }
    Array.prototype.forEach.call(document.querySelectorAll('[data-pz-cart-notice]'), function (box) {
      box.hidden = true;
      box.textContent = '';
      box.removeAttribute('data-pz-notice-at');
    });
  }

  /* お知らせの本文（portal の replaceNoticeText と同じ文。デザインID は付けない。数字の前後に空白を入れない） */
  function noticeText(data) {
    return 'カート内の' + Number(data.replacedCount || 0) + '点も新しいデザインにしました。' + (data.priceChanged ? '金額が変わっています' : '');
  }

  /* ログインして端末のカートをまとめた知らせ（段階 6） */
  function mergedText(data) {
    return 'ログイン前のカートをまとめました（' + Number(data.itemCount || 0) + '点）';
  }

  function itemName(x) {
    return [x && x.productName, x && x.color].filter(Boolean).join(' ');
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  /* 差し替えの知らせ（段階 4）の本文 */
  function fillReplaced(body, data) {
    body.appendChild(el('strong', 'pz-cart-notice__title', 'デザインを更新しました'));
    if (Number(data.replacedCount) > 0) body.appendChild(el('p', 'pz-cart-notice__text', noticeText(data)));
    var removed = Array.isArray(data.removed) ? data.removed : [];
    if (removed.length) {
      body.appendChild(el('p', 'pz-cart-notice__text', 'カートから外しました: ' + removed.map(itemName).join('、')));
    }
    var failed = Array.isArray(data.failed) ? data.failed : [];
    failed.forEach(function (x) {
      body.appendChild(
        el(
          'p',
          'pz-cart-notice__text pz-cart-notice__text--warn',
          '新しいデザインにできなかった商品: ' + itemName(x) + (x && x.message ? '（' + x.message + '）' : '') + '。前のデザインのままカートに残っています'
        )
      );
    });
    if (Number(data.removeFailed) > 0) {
      body.appendChild(
        el(
          'p',
          'pz-cart-notice__text pz-cart-notice__text--warn',
          '前のデザインの商品を' + Number(data.removeFailed) + '点消せませんでした。お手数ですが、カートで削除してください'
        )
      );
    }
    if (data.checkoutStarted) body.appendChild(el('p', 'pz-cart-notice__text pz-cart-notice__text--warn', CHECKOUT_OPEN_NOTICE));
  }

  function fill(box, data) {
    box.textContent = '';
    var body = el('div', 'pz-cart-notice__body');
    if (data.kind === 'merged') body.appendChild(el('strong', 'pz-cart-notice__title', mergedText(data)));
    else fillReplaced(body, data);
    box.appendChild(body);
    var close = el('button', 'pz-cart-notice__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'お知らせを閉じる');
    close.addEventListener('click', clear);
    box.appendChild(close);
    box.setAttribute('data-pz-notice-at', String(data.at));
    box.hidden = false;
  }

  /* 入れ物ごとに出す（同じお知らせを出し済みの入れ物はそのまま。描き直しで中身が消えた入れ物には出し直す） */
  function render() {
    var data = read();
    var boxes = document.querySelectorAll('[data-pz-cart-notice]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (!data) {
        if (!box.hidden) {
          box.hidden = true;
          box.textContent = '';
        }
        return;
      }
      if (box.getAttribute('data-pz-notice-at') === String(data.at) && box.firstChild) return;
      fill(box, data);
    });
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () {
      timer = null;
      render();
    }, 50);
  }

  function boot() {
    render();
    /* カートのページはセクションを描き直す（枚数の変更・料金の行の作り直し）。入れ物が作り直されたら出し直す */
    if (window.MutationObserver && document.body) {
      new window.MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes && records[i].addedNodes.length) {
            schedule();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    /* ほかのタブ（専用ページ）で差し替えたら出す */
    window.addEventListener('storage', function (ev) {
      if (ev.key === STORAGE_KEY) render();
    });
  }

  window.PzCartNotice = { render: render, clear: clear, read: read, text: noticeText, mergedText: mergedText };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
